import { definePage } from '@reflex/plugin-api/web';
import type { PluginWebManifest } from '@reflex/plugin-api/web';

/**
 * Browser-safe web manifest — imported by both the plugin definition
 * (server side) and `web/register.ts` (browser side). Must never import
 * server code or the root `@reflex/plugin-api` barrel: this file is what
 * keeps the web bundle free of the plugin's server graph.
 */
const page = definePage({
  path: '/crews',
  label: 'Crews',
  icon: 'Users',
  group: 'misc',
  componentPath: '@reflex/plugin-crew/web/CrewPage',
  description: 'AI software teams that run on data definitions.',
});

export const crewWebManifest: PluginWebManifest = {
  ...page.web,
  originators: [{ idPrefix: 'ctr', label: 'Crew' }],
  eventLabels: [
    {
      type: 'crew.task_dispatched',
      label: 'Task dispatched',
      tooltip: 'The charter dispatched a task to an actor',
      style: 'system',
    },
    {
      type: 'crew.task_completed',
      label: 'Task completed',
      tooltip: 'An actor finished its task',
      style: 'system',
    },
    {
      type: 'crew.task_failed',
      label: 'Task failed',
      tooltip: 'A task run ended in failure',
      style: 'system',
    },
    {
      type: 'crew.result_published',
      label: 'Result published',
      tooltip: 'A typed result landed on the team thread',
      style: 'system',
    },
    {
      type: 'crew.actor_post',
      label: 'Actor post',
      tooltip: 'A progress note from a working actor',
      style: 'bubble',
    },
    {
      type: 'crew.gate_requested',
      label: 'Gate requested',
      tooltip: 'A human decision was requested',
      style: 'system',
    },
    {
      type: 'crew.gate_resolved',
      label: 'Gate resolved',
      tooltip: 'A human decision resolved a gate',
      style: 'system',
    },
    {
      type: 'crew.escalation',
      label: 'Escalation',
      tooltip: 'The charter escalated to the conductor',
      style: 'system',
    },
  ],
};
